import { augmentError } from '../../utils/errors';
import User from '../../models/User';
import api from '../../utils/api';
import constants from '../constants';

const UserActions = {
  getUser({ pageWithSensitiveInformation = false } = {}) {
    return (dispatch) =>
      dispatch(api.user.info({ pageWithSensitiveInformation, includeSummary: true })).then((response = {}) => {
        const userModel = User(response);

        dispatch(UserActions.updateUserInfo(userModel));

        return userModel;
      });
  },
  getPromiseRejection() {
    return () => Promise.reject(new Error('bad mojo'));
  },
  getThrownError(message, data) {
    return () =>
      new Promise(() => {
        const error = new Error(message);
        augmentError(error, data);

        throw error;
      });
  },
  updateUserInfo(data) {
    return (dispatch) =>
      dispatch({
        type: constants.UPDATE_USER_INFO,
        payload: data,
      });
  },
};

export default UserActions;
